import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import SEO from "../components/site/SEO";
import { GARAGE } from "../lib/constants";

export default function NotFound() {
  return (
    <>
      <SEO
        title="Page introuvable — Promo Pneus, Le Cannet"
        description="La page demandée n'existe pas. Retournez à l'accueil de Promo Pneus, garage au Cannet, ou appelez le 04 93 46 39 67."
      />
      <section className="bg-brand-dark py-24 sm:py-32" data-testid="page-404">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="font-heading font-bold text-[8rem] sm:text-[12rem] leading-none text-brand-red" aria-hidden="true">
            404
          </p>
          <h1 className="font-heading font-bold uppercase text-3xl sm:text-4xl text-white tracking-wide -mt-6">
            Cette page a crevé.
          </h1>
          <p className="mt-6 text-white/70 text-lg max-w-xl mx-auto">
            La page que vous cherchez n'existe pas ou a été déplacée. Revenez à l'accueil
            ou appelez directement l'atelier.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/" data-testid="lien-404-accueil"
              className="bg-brand-red hover:bg-brand-redhover text-white font-heading font-semibold uppercase tracking-wider text-lg px-8 py-4 transition-colors">
              Retour à l'accueil
            </Link>
            <a href={`tel:${GARAGE.telephoneLien}`} data-testid="lien-404-telephone"
              className="inline-flex items-center justify-center gap-3 bg-white hover:bg-brand-light text-brand-dark font-heading font-semibold uppercase tracking-wider text-lg px-8 py-4 transition-colors">
              <Phone size={20} aria-hidden="true" />
              {GARAGE.telephone}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
